import {
  CLEAR_PLACE_ORDER,
  PLACE_ORDER,
  PLACE_ORDER_FULFILLED,
  PLACE_ORDER_REJECTED,
} from 'b2b-apps/shop/checkout/redux/order/actionTypes';
import {
  ClearPlaceOrderAction,
  PlaceOrderAction,
  PlaceOrderFulfilledAction,
  PlaceOrderRejectedAction,
} from 'b2b-apps/shop/checkout/redux/order/types';
import { CheckoutDataType } from 'b2b-common/core/checkout/Checkout.types';

const clearPlaceOrder = (): ClearPlaceOrderAction => ({
  type: CLEAR_PLACE_ORDER,
});

const placeOrder = (checkoutId: string): PlaceOrderAction => ({
  type: PLACE_ORDER,
  payload: {
    checkoutId,
  },
});

const placeOrderFulfilled = (checkoutId: string, data: CheckoutDataType): PlaceOrderFulfilledAction => ({
  type: PLACE_ORDER_FULFILLED,
  payload: {
    checkoutId,
    data,
  },
});

const placeOrderRejected = (checkoutId: string, error: ErrorType): PlaceOrderRejectedAction => ({
  type: PLACE_ORDER_REJECTED,
  payload: {
    checkoutId,
    error,
  },
});

export { clearPlaceOrder, placeOrder, placeOrderFulfilled, placeOrderRejected };
